import React from 'react';
import {useNavigate} from "react-router-dom";
import {Divider} from "primereact/divider";
import {Button} from "primereact/button";

function NoCase(props) {
    const navigate = useNavigate();
    return(
        <div className="w-full bg-white border-round-xl shadow-1 p-3 flex flex-column justify-content-between align-items-center">
            <div className="flex flex-column text-sm w-full">
                <span className="font-bold">ثبت تیکت (درخواست)</span>
                <span className="text-gray-500">پیش از این درخواست توسط شما ثبت نشده است.</span>
            </div>
            <Divider className="mt-2"/>
            <img className="w-full p-6 lg:w-30rem" src={`${process.env.PUBLIC_URL}/assets/images/ticket.png`}/>
            <Button className="w-full border-round-lg" label="ثبت تیکت" onClick={()=>{navigate("/case/create")}}/>
        </div>
    )
}

export default NoCase;